module.exports = __webpack_public_path__ + "05_bob_gold.4f15a6f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/05_bob_gold.png
// module id = LWR9
// module chunks = 0